import PropTypes from 'prop-types'

export const game_proptype = PropTypes.shape({
  created_at: PropTypes.string,
  desktopSlug: PropTypes.string,
  mobileSlug: PropTypes.string,
  title: PropTypes.string,
  slug: PropTypes.string,
  mock: PropTypes.bool,
  disable_play_for_fun: PropTypes.bool,
  providerName: PropTypes.string,
  providerCode: PropTypes.string,
  providerSlug: PropTypes.string,
  thumbnail: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    sizes: PropTypes.shape({
      medium: PropTypes.string,
      medium_large: PropTypes.string,
      large: PropTypes.string,
    }),
  }),
  thumbnail_tall: PropTypes.shape({
    url: PropTypes.string,
    title: PropTypes.string,
    sizes: PropTypes.shape({
      medium: PropTypes.string,
      medium_large: PropTypes.string,
      large: PropTypes.string,
    }),
  }),
  game_tags: PropTypes.arrayOf(PropTypes.string),
})
